import { Icon } from '~/components/ui/icons/icon.tsx'
import { type ComboboxProps } from '../../combobox.tsx'
import { ComboboxField, type ListOfErrors } from '../../forms.tsx'
import { countries } from './countries.ts'

export function CountriesSelect({
  labelProps,
  inputProps,
  errors,
  className,
}: {
  labelProps: React.LabelHTMLAttributes<HTMLLabelElement>
  inputProps: React.InputHTMLAttributes<HTMLInputElement> &
    Omit<ComboboxProps, 'options'>
  errors?: ListOfErrors
  className?: string
}) {
  const countryOptions = Object.entries(countries).map(([code, name]) => ({
    value: code,
    label: (
      <div className="flex items-center gap-1">
        {/* @ts-ignore */}
        <Icon name={`flags/${code.toLowerCase()}`} />
        <span>{name}</span>
      </div>
    ),
    labelTrigger: name,
  }))

  return (
    <ComboboxField
      labelProps={labelProps}
      className={className}
      inputProps={{
        variant: 'filled',
        options: countryOptions,
        ...inputProps,
      }}
      errors={errors}
    />
  )
}
